import { Logo } from "@cocunat/ui-components";
import { t } from "../helpers";
import { useParams } from "react-router-dom";
import { LocaleParams } from "../types";
function Header() {
  const { lang, country } = useParams<LocaleParams>();

  return (
    <div id="header">
      <div className="logo">
        <Logo />
      </div>

      <div className="headerLinks">
        <p>
          {" "}
          <a href={`/${lang}-${country}/quizz/1/`}>{t("headerLink1")}</a>
        </p>

        <p style={{ color: "#EF8877 !important", fontFamily: "Brown-Regular" }}>
          <a href={`/${lang}-${country}/quizz/1/`} className="salmon">
            {t("headerLink2")}
          </a>
        </p>
      </div>
    </div>
  );
}
export default Header;
